<script lang="ts">
import SettingsBox from '../../elements/SettingsBox.svelte';
import Title from "../../elements/settings/Title.svelte";
import TitleIcon from "../../elements/settings/TitleIcon.svelte";
import PrimaryBox from "../../elements/settings/PrimaryBox.svelte";
import Booleans from "../../elements/settings/Buttons/Booleans.svelte";
import { presentation } from '../../../stores/storedSettings';
</script>

<SettingsBox bordered={false} id="high-contrast">
    <Title title="高对比度">
        <TitleIcon>
            <i class="icon-lightbulb text-primary settings-title-icon transition-opacity" class:opacity-50={!$presentation} style="color: #fcf4ac;"></i>
        </TitleIcon>
    </Title>
    <PrimaryBox 
        label={{text: '保持鲜艳的颜色'}} 
        description={{text:'当屏幕保护程序激活时保持颜色明亮鲜艳，如果你想让<b>放松时钟</b>闪耀，这非常有用！', iconClass: 'lnr lnr-question-circle'}}
        available={true}
    >
        <Booleans state={$presentation} label={'高对比度'} on:change={(e) => presentation.set(e.detail)}/>
    </PrimaryBox>
</SettingsBox>